import { ICallStatusOptionMapping } from 'buddy-api/types/callstatus'
import ApiMixin from '../ApiMixin'

export default class CallStatusOptionsAPI extends ApiMixin<ICallStatusOptionMapping> {}
